import {
  baseContainer,
  interactiveContainer,
  dangerContainer,
  iconMargin,
  successIcon,
  dangerIcon,
  warningIcon,
  successText,
  neutralText,
  notApplicableText,
  selectPaymentText,
} from "../styles_vanilla.css";
import { warningContainer, dangerText, warningText } from "./styles_vanilla.css";
import { ScreeningStatusType, StatusConfig } from "./types";

export const STATUS_CONFIG: Record<ScreeningStatusType, StatusConfig> = {
  "true-match": {
    containerClass: `${baseContainer} ${dangerContainer}`,
    icon: {
      type: "exclamation-circle",
      variant: "outline",
      className: `${iconMargin} ${dangerIcon}`,
    },
    text: {
      content: "True match",
      className: dangerText,
    },
    viewText: "View",
  },
  "potential-match": {
    containerClass: `${baseContainer} ${warningContainer}`,
    icon: {
      type: "exclamation-triangle",
      variant: "outline",
      className: `${iconMargin} ${warningIcon}`,
    },
    text: {
      content: "Potential Match",
      className: warningText,
    },
    viewText: "Review",
  },
  "no-matches-found": {
    containerClass: `${baseContainer} ${interactiveContainer}`,
    icon: {
      type: "check",
      className: `${iconMargin} ${successIcon}`,
    },
    text: {
      content: "No matches found",
      className: successText,
    },
    viewText: "View",
  },
  "accepted-by-gp": {
    containerClass: `${baseContainer} ${interactiveContainer}`,
    icon: {
      type: "check",
      className: `${iconMargin} ${successIcon}`,
    },
    text: {
      content: "Accepted by GP",
      className: successText,
    },
    viewText: "View",
  },
  "false-positive": {
    containerClass: `${baseContainer} ${interactiveContainer}`,
    icon: {
      type: "check",
      className: `${iconMargin} ${successIcon}`,
    },
    text: {
      content: "False Positive",
      className: successText,
    },
    viewText: "View",
  },
  "rejected-by-gp": {
    containerClass: `${baseContainer} ${dangerContainer}`,
    icon: {
      type: "xmark",
      className: `${iconMargin} ${dangerIcon}`,
    },
    text: {
      content: "Rejected by GP",
      className: dangerText,
    },
    viewText: "View",
  },
  "select-payment-beneficiary": {
    containerClass: baseContainer,
    text: {
      content: "Select payment beneficiary",
      className: `${neutralText} ${selectPaymentText}`,
    },
  },
  "not-applicable": {
    containerClass: baseContainer,
    text: {
      content: "--",
      className: notApplicableText,
    },
  },
} as const;
